module.exports = __webpack_public_path__ + "img/positive-news-covid-02.e5297a06.jpg";